angular.module('ApptBookApp').filter('client', function () {
    return function (client) {
        if (!isObject(client)) {
            return '';
        };

        if (client.clientType == Meevo.Model.ClientTypeEnum.AnonymousMale ||
            client.clientType == Meevo.Model.ClientTypeEnum.AnonymousFemale ||
            client.clientType == Meevo.Model.ClientTypeEnum.AnonymousOther) {
            return client.displayName;
        }

        return client.lastName + ', ' + client.firstName;
    };
});